import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { InputMoneyProps } from '../../../../../../../components/InputMoney';
import {
  AssetDefaultOrSelectedTypeMap,
  AssetSelectedTypeMap,
} from '../../../../../../../store/product/types';
import { useFundAddedProductItem } from '../../../../../hooks';
import {
  AddedProductItemList,
  AddedProductItemRouteParamTypeProps,
  AssetWithErrorResponse,
} from '../../../../../utils/types';
import { AddedProductItemContainer } from '../Container';

import { AddedProductItemFundsDesktop } from './desktop';
import { AddedProductItemFundsMobile } from './mobile';
import { AddedProductItemFundsSkeleton } from './skeleton';
import { AddedProductItemFundsTablet } from './tablet';

type FundDataProps = AssetDefaultOrSelectedTypeMap['funds'] & AssetWithErrorResponse;

export interface AddedProductItemFundsProps {
  data: AssetSelectedTypeMap['funds'];
  type: AddedProductItemRouteParamTypeProps;
  isInvalid?: boolean;
  orderIsRecused?: boolean;
}

export interface AddedProductResponsiveItemFundsProps {
  data: FundDataProps;
  inputMoneyDataProps: InputMoneyProps;
  minimumMovimentationFormatted: string;
  onRemoveProduct: () => void;
}

export const AddedProductItemFunds: React.FC<AddedProductItemFundsProps> = ({
  data,
  type,
  isInvalid,
  orderIsRecused,
}) => {
  const { inputMoneyDataProps, minimumMovimentationFormatted, onRemoveProduct, isLoadingAction } =
    useFundAddedProductItem({
      data,
      type,
    });

  const lateralBarBackgroundColor = isInvalid ? 'feedback.attention.lightest' : 'product.fundos';

  const params = {
    data,
    inputMoneyDataProps,
    minimumMovimentationFormatted,
    onRemoveProduct,
  };

  const layout = useBreakpointValue({
    base: <AddedProductItemFundsMobile {...params} />,
    sm: <AddedProductItemFundsTablet {...params} />,
    lg: <AddedProductItemFundsDesktop {...params} />,
  });

  if (isLoadingAction) {
    return <AddedProductItemFundsSkeleton />;
  }

  return (
    <AddedProductItemContainer
      data={data as AddedProductItemList}
      isInvalid={!!isInvalid}
      key={data.productId}
      orderIsRecused={!!orderIsRecused}
      lateralBarBackgroundColor={lateralBarBackgroundColor}>
      {layout}
    </AddedProductItemContainer>
  );
};
